import { render, staticRenderFns } from "./PopupNotify.vue?vue&type=template&id=6ffea2e1&"
import script from "./PopupNotify.vue?vue&type=script&lang=js&"
export * from "./PopupNotify.vue?vue&type=script&lang=js&"
import style0 from "./PopupNotify.vue?vue&type=style&index=0&id=6ffea2e1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports